// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a5ba7541","879":"2f6330b9"}[chunkId] + ".chunk.js";
};